import React from 'react';
import { Play } from 'lucide-react';
import { PRESETS } from '../data/content';
import { CHAPTERS, POSTER } from '../data/script';
import { cx } from '../lib/hooks';
import { TOTAL_MS, formatTime } from '../lib/timeline';
type Props = {
  presetId: string;
  onPreset: (id: string) => void;
  onPlay: () => void;
  onExplore: () => void;
};
export function PosterCard({
  presetId,
  onPreset,
  onPlay,
  onExplore
}: Props) {
  return <div className="absolute inset-0 z-40 flex items-center justify-center bg-[radial-gradient(ellipse_at_center,rgba(7,8,12,0.72)_0%,rgba(7,8,12,0.94)_75%)] px-6 backdrop-blur-[10px]" data-id="element-209" data-mp="6awnfm95qtgm">
      <div className="max-w-[560px] text-center animate-[fadeUp_0.6s_ease_both]" data-id="element-210" data-mp="3thgw5a8zt61b">
        <div className="text-[11px] font-medium uppercase tracking-[0.12em] text-[#9A9FB0]" data-id="element-211" data-mp="29l7k8g35mlm">
          An interactive film · {CHAPTERS.length} chapters · {formatTime(TOTAL_MS)}
        </div>
        <h1 className="mt-3 text-[52px] font-semibold leading-[56px] tracking-[-0.03em] text-[#EDEEF2] max-sm:text-[36px] max-sm:leading-[40px]" data-id="element-212" data-mp="3oh1jym0g64kx">
          {POSTER.title}
        </h1>
        <p className="mx-auto mt-4 max-w-[440px] text-[15px] leading-6 text-[#9A9FB0]" data-id="element-213" data-mp="2mowwi6ivd9u2">{POSTER.setup}</p>

        <button type="button" onClick={onPlay} className="mx-auto mt-8 flex h-14 items-center gap-3 rounded-full bg-white pl-6 pr-7 text-[15px] font-semibold text-[#07080C] shadow-[0_18px_50px_-18px_rgba(255,255,255,0.45)] transition-transform duration-200 hover:scale-[1.03] active:scale-[0.98]" data-id="element-214" data-mp="30opl9wau5fze">
          <Play className="h-5 w-5" fill="currentColor" data-id="element-215" data-mp="23zhykkyhd0tw" />
          Play film
        </button>

        <div className="mt-8 text-[11px] font-medium uppercase tracking-[0.08em] text-[#5D6272]" data-id="element-216" data-mp="2hqvbvh5sp2gh">
          Sentence to finish
        </div>
        <div className="mt-2 flex flex-wrap justify-center gap-1.5" data-id="element-217" data-mp="2cx0l5trrvn7w">
          {PRESETS.map(p => <button key={p.id} type="button" onClick={() => onPreset(p.id)} className={cx('h-8 rounded-full border px-3 font-mono text-[12px] transition-colors', p.id === presetId ? 'border-white/25 bg-white/[0.12] text-[#EDEEF2]' : 'border-white/[0.08] bg-white/[0.03] text-[#9A9FB0] hover:bg-white/[0.07] hover:text-[#EDEEF2]')} data-id="element-218" data-mp="1p7693efa22op">
              {p.label}…
            </button>)}
        </div>

        <button type="button" onClick={onExplore} className="mt-6 text-[13px] text-[#9A9FB0] transition-colors hover:text-[#EDEEF2]" data-id="element-219" data-mp="31f4r088qs5j1">
          Skip to explore
        </button>
      </div>
    </div>;
}